// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import getAxisFromEventFieldName from '../getAxisFromEventFieldName'
import handleCoordinateFieldFormatting from '../handleCoordinateFieldFormatting'

// handles onPaste event for coordinate fields
// this way we can format the coordinate value immediately after paste
// and not always force the user to blur to see the format applied.

const handleOnPasteCoordinateField = (e, applyChange) => {
  // prevent the default paste behavior. Otherwise, the applyChange will be triggered (updates redux-form value)
  // THEN
  // the default onPaste event will append the pasted value to the current input field's value.
  // like doubling what you meant to paste.
  e.preventDefault()
  const axis = getAxisFromEventFieldName(e)
  const clipboardData = e.clipboardData || window.clipboardData
  const pastedData = clipboardData.getData('text').trim()
  handleCoordinateFieldFormatting(pastedData, axis, applyChange)
}

export default handleOnPasteCoordinateField
